const getLocalUrl = (file) => {
  console.log("get local url...");

  if (file instanceof File) {
    return URL.createObjectURL(file);
  }
  return file;
};

const numberWithCommas = (x, digit = 0) => {
  if (!x || !Number(x)) return (0).toFixed(digit).toString();
  x = x.toFixed(digit);
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};

module.exports = {
  getLocalUrl,
  numberWithCommas,
};

document.addEventListener("wheel", () => {
  if (document.activeElement.type === "number") {
    document.activeElement.blur();
  }
});
